import { MutationCache, QueryClient } from '@tanstack/react-query'

export const queryClient = new QueryClient({
	defaultOptions: {
		queries: { retry: 0, refetchOnWindowFocus: true },
		mutations: { retry: 0 },
	},
	mutationCache: new MutationCache({
		// Read-only mutations (e.g. minting a share message) opt out via
		// `meta: { skipInvalidate: true }` to avoid refetching everything.
		onSuccess: (_data, _vars, _ctx, mutation) => {
			if (mutation.meta?.skipInvalidate) return
			queryClient.invalidateQueries({ type: 'active' })
		},
	}),
})
